(function() {
	'use strict';


	angular.module('flightWatch').controller(
			'ConfirmIllegalFleetCrewAssignCtrl',
    ConfirmIllegalFleetCrewAssignCtrl);

	function ConfirmIllegalFleetCrewAssignCtrl($uibModalInstance, modalParams,
			EventManagerService) {
		var vm = this;
		vm.ctrlName = 'illegalFleetCrewAssign';

		vm.model = {
			crewList : modalParams.crewList,
      modelNumber: modalParams.modelNumber
		};

		vm.onButtonClick = function(flag) {
			$uibModalInstance.close(flag);
		};

		vm.onCloseClick = function() {
			$uibModalInstance.close();
		};
	}
}());
